const book_list = [
  {
    id: '25742',
    name: '河庄梦情',
    description: '（男主：白爷）作者立足于乡土，着眼于中国普通民众，着眼于爱国主义和革命情怀，用近乎白描的手法，全景式展现了民国后期中原大地上各行各业的人物。绘声绘色地讲述了当山河破碎、风雨飘摇之际，一群有正义有血性的中华好儿女，没有随遇而安，随波逐流，听任欺凌。他们历经爱恨情仇、人间冷暖、社会变迁，勇敢地拿起武器，奔走呼告，化解乡间矛盾、弥合国民内部矛盾，战土匪、收溃军、灭日寇、迎光明！ 2018年该作品获得中国作家协会重点作品扶持，并且获得了2018年江苏省首届原创网络文学大赛优胜奖。',
    author: '笑波客',
    cate1_id: '283',
    word_count: '2290532',
    cover: 'https://readstatic.zhulang.com/res/admincover/025/742/25742_180.jpg'
  },
  {
    id: '551433',
    name: '侠光向阳生',
    description: '国之大者，君为之任；侠之大者，为国为民。这是一个百岁老党员李廷魁的人生故事。李廷魁的一生充满了传奇色彩，他先后化身为战斗英雄、光明使者、报恩赤子和泽教老人，如同一根蜡烛照亮了别人燃烧了自己，将自己的一生无私地奉献给了国家、家乡和人民，唯独没有他自己。',
    author: '笑波客',
    cate1_id: '283',
    word_count: '230599',
    cover: 'https://readstatic.zhulang.com/res/cover/551/433/551433_180.jpg'
  },
  {
    id: '556886',
    name: '空战英豪：陈怀民传',
    description: '2025年是世界反法西斯战争胜利80周年，在2015年由民政部公布的第二批著名抗日英烈和英雄群体名录中有一位著名的镇江籍烈士，牺牲时年仅22岁的中国空军飞行员陈怀民。 陈怀民在4.29武汉空战时负伤，放弃跳伞，加速撞向日军王牌飞行员“红武士”高桥宪一，与敌同归于尽，极大地鼓舞了抗日军民的士气。周恩来总理为陈怀民题写挽联“义薄云天 捐躯报国”，朱德总司令称其为“精忠神勇”。 陈怀民是世界空战史上敢与于敌机对撞同归于尽的第一人，是中国空军从反法西斯战场一路走来，驰骋蓝天的军魂，鼓舞着一代代又一代代中国空军为守卫祖国的领空而舍生忘死！',
    author: '情殇孤月',
    cate1_id: '26',
    word_count: '126788',
    cover: 'https://readstatic.zhulang.com/res/cover/556/886/556886_180.jpg'
  }
]

const video_list = [
  {
    cover: 'https://readstatic.zhulang.com/res/upload/00c024ee952ab34cc00993a3f3759c0f.png',
    videoUrl: 'https://readstatic.zhulang.com/res/upload/a9a7659bf43e9296c317b393ccbb189d.mov',
    description: '情殇孤月，本名胡浩，民盟盟员，中国作家协会会员，江苏省第八批签约作家，镇江市青联副秘书长。代表作《空战英豪：陈怀民传》入选江苏省作协2025年度文学项目，《弄江潮》荣获2020扬子江网络文学作品大赛三等奖。',
  },
  {
    cover: 'https://readstatic.zhulang.com/res/upload/d50e38ab5a8e9a78033162d99ffd9800.png',
    videoUrl: 'https://readstatic.zhulang.com/res/upload/19ff43eb3ca1afa83d34ece2b5511857.mov',
    description: '笑波客，本名石吉刚，鲁迅文学院学员，中国作家协会会员。创作长篇小说10部，短篇小说和散文数十篇，代表作《河庄梦情》入选中国作家协会重点作品扶持项目，并获江苏省首届网络文学原创作品大赛优胜奖，《河庄守望》获2021年扬子江网络文学作品大赛三等奖。',
  },
  {
    cover: 'https://readstatic.zhulang.com/res/upload/25b92ad3fe337f949ef3fd0771db03d8.png',
    videoUrl: 'https://readstatic.zhulang.com/res/upload/40f1ba1788879e817889dded15290a2d.mov',
    description: '煜素，本名江萍萍，中国作家协会会员，江苏省网络作家协会理事。代表作《一条搜救犬的见证》荣获2021扬子江网络文学作品大赛三等奖，职场题材小说《随时待命》长期占据同类作品榜单前十；《江渔》获2023年中国作家协会网络文学重点项目扶持；《陪伴之路》入选江苏省作协2024年度文学项目。',
  },
  {
    cover: 'https://readstatic.zhulang.com/res/upload/45e868e41eedbeaec7be4d6961d7d794.png',
    videoUrl: 'https://readstatic.zhulang.com/res/upload/816df247ee0778a4392013babffb5b18.mov',
    description: '大橙子，本名程梦婷，湖北省作家协会会员。其创作的《刺猬的微光》入选2021中国数字阅读大会IP峰会“鹤鸣杯”IP潜力价值榜。名下多部作品获影视改编，短剧《绝胜烟柳满皇都》已播出，动画《洪荒志之青丘劫云》及都市情感剧《驭心》即将上映。',
  },
  {
    cover: 'https://readstatic.zhulang.com/res/upload/c5e78ee38816e04e331e9fc9befc7d38.png',
    videoUrl: 'https://readstatic.zhulang.com/res/upload/dd6513bc30faaf944c786ce6853525ed.mov',
    description: '红色十月，本名吴文贤，擅长历史军事题材创作。自2009年起在连尚文学逐浪网陆续发表《鹰派大佬》《大将》《荣耀》《荣光》等作品，目前正在连载的《黎明前的黑夜》文风硬朗，叙事扎实，细节考究。',
  },
  {
    cover: 'https://readstatic.zhulang.com/res/upload/605b6f9a13edde7a16df589b96948415.png',
    videoUrl: 'https://readstatic.zhulang.com/res/upload/72bfc9de6ff56d27a77b537e30cef3ae.mov',
    description: '清竹小兔，本名郭杨，新晋女性小说作家，擅长将现代思维融入古代背景，以幽默诙谐的笔触刻画人物互动，文风活泼细腻，笔下故事兼具趣味性与情感张力，深受年轻读者喜爱。',
  }
]

const cate_map = {
  "1": "修真武侠",
  "2": "传统武侠",
  "3": "古典仙侠",
  "4": "现代仙侠",
  "5": "武侠幻想",
  "6": "玄幻小说",
  "7": "东方玄幻",
  "8": "西方魔幻",
  "9": "异界争霸",
  "10": "现代魔法",
  "11": "洪荒史诗",
  "12": "现代修真",
  "13": "异能奇书",
  "14": "黑暗幻想",
  "15": "动漫游戏",
  "16": "武侠同人",
  "17": "影视同人",
  "18": "动漫同人",
  "19": "游戏同人",
  "21": "小说同人",
  "22": "历史小说",
  "23": "历史传记",
  "24": "穿越历史",
  "25": "架空历史",
  "26": "军事小说",
  "27": "战争幻想",
  "28": "军旅生涯",
  "29": "谍战特工",
  "30": "都市小说",
  "31": "都市生活",
  "32": "热血成长",
  "33": "都市异能",
  "34": "娱乐明星",
  "35": "青春校园",
  "36": "职场商战",
  "37": "科幻小说",
  "38": "未来世界",
  "39": "宇宙争霸",
  "40": "古武机甲",
  "41": "未世进化",
  "42": "时空穿梭",
  "43": "超级科技",
  "44": "网游小说",
  "45": "游戏生涯",
  "46": "电子竞技",
  "47": "虚拟网游",
  "48": "游戏异界",
  "50": "推理",
  "51": "推理悬念",
  "52": "恐怖惊悚",
  "53": "灵异鬼怪",
  "54": "风水秘术",
  "55": "探险异闻",
  "56": "竞技体育",
  "57": "体育竞技",
  "58": "篮球运动",
  "59": "足球运动",
  "60": "棋牌桌游",
  "61": "现代言情",
  "62": "都市情缘",
  "63": "总裁豪门",
  "64": "婚恋家庭",
  "65": "职场白领",
  "66": "异术超能",
  "67": "娱乐巨星",
  "68": "古代言情",
  "69": "古代情缘",
  "70": "穿越架空",
  "71": "女尊权谋",
  "72": "宫闱宅斗",
  "73": "经商种田",
  "74": "古代历史",
  "75": "浪漫青春",
  "76": "青春校园",
  "77": "禁忌绝恋",
  "78": "百合之恋",
  "79": "原创耽美",
  "80": "同人耽美",
  "81": "玄幻异能",
  "82": "玄幻异世",
  "83": "奇幻魔法",
  "84": "悬疑",
  "85": "推理探案",
  "86": "惊悚恐怖",
  "87": "灵异志怪",
  "88": "神秘文化",
  "89": "古墓迷踪",
  "90": "武侠仙侠",
  "91": "仙侠奇缘",
  "92": "古典仙侠",
  "93": "洪荒封神",
  "94": "动漫游戏",
  "95": "女生同人",
  "96": "换身入替",
  "97": "萌系小说",
  "99": "古装",
  "100": "武侠",
  "101": "言情",
  "102": "伦理",
  "103": "都市",
  "104": "职场",
  "106": "古典名著",
  "107": "现代名著",
  "108": "社科科普",
  "109": "经管励志",
  "111": "国外青春文学",
  "112": "港台青春文学",
  "113": "韩国青春文学",
  "114": "爱情情感",
  "115": "校园",
  "116": "叛逆成长",
  "118": "外文小说",
  "119": "情感小说",
  "120": "官场职场",
  "121": "文史传记",
  "122": "宗教哲学",
  "123": "生活随笔",
  "125": "各国历史",
  "126": "通俗说史",
  "127": "文物考古",
  "128": "地方史志",
  "129": "史家专著",
  "130": "历史随笔",
  "132": "历史人物",
  "133": "人物集合",
  "134": "艺术家",
  "135": "法律人物",
  "136": "宗教人物",
  "137": "女性人物",
  "139": "婚姻",
  "140": "性知识",
  "141": "婚恋综合",
  "142": "恋爱",
  "143": "育儿",
  "145": "政治理论",
  "146": "中国政治",
  "147": "世界政治",
  "148": "外交国际关系",
  "149": "各国政治",
  "150": "公共管理",
  "151": "政党读物",
  "156": "军事史",
  "159": "其他",
  "160": "其他",
  "161": "其他",
  "162": "其他",
  "163": "职场商战",
  "165": "青年文学",
  "166": "青年文摘",
  "167": "短篇",
  "168": "都市小说",
  "169": "玄幻科幻",
  "170": "灵异悬疑",
  "171": "武侠仙侠",
  "172": "历史军事",
  "173": "同人小说",
  "174": "其他",
  "175": "短篇",
  "176": "总裁豪门",
  "177": "婚恋职场",
  "178": "穿越架空",
  "179": "宫斗宅斗",
  "180": "悬疑灵异",
  "181": "浪漫青春",
  "182": "其他",
  "183": "都市情感",
  "184": "婚姻与家庭",
  "185": "2018年",
  "186": "2015年",
  "187": "2016年",
  "188": "2017年",
  "189": "2018年",
  "190": "体育健康",
  "191": "足球周刊",
  "192": "玄幻",
  "193": "都市",
  "194": "恐怖",
  "195": "校园",
  "196": "悬疑",
  "197": "科幻",
  "198": "生活",
  "199": "热血",
  "200": "爆笑",
  "201": "纯爱",
  "202": "历史",
  "203": "少儿",
  "204": "动作",
  "205": "战争",
  "206": "彩虹",
  "207": "萌系",
  "208": "穿越",
  "209": "后宫",
  "210": "唯美",
  "211": "玄幻",
  "212": "都市",
  "213": "恐怖",
  "214": "校园",
  "215": "悬疑",
  "216": "科幻",
  "217": "生活",
  "218": "热血",
  "219": "爆笑",
  "220": "纯爱",
  "221": "历史",
  "222": "少儿",
  "223": "动作",
  "224": "战争",
  "225": "彩虹",
  "226": "萌系",
  "227": "穿越",
  "228": "后宫",
  "229": "唯美",
  "230": "古风",
  "231": "古风",
  "232": "魔幻",
  "233": "魔幻",
  "234": "治愈",
  "235": "治愈",
  "236": "武侠",
  "237": "武侠",
  "238": "知音",
  "239": "故事传奇",
  "240": "山海经",
  "241": "2018",
  "242": "2017",
  "246": "2016",
  "247": "2018",
  "248": "2017",
  "249": "今古传奇故事版",
  "250": "2018",
  "251": "2017",
  "252": "2016",
  "253": "今古传奇单月号",
  "254": "2017",
  "255": "2018",
  "256": "2018",
  "257": "2017",
  "258": "2016",
  "259": "2018",
  "260": "2017",
  "261": "2016",
  "262": "2015",
  "263": "经典武侠",
  "264": "金庸全集",
  "265": "梁羽生全集",
  "266": "古龙精选",
  "267": "经典言情",
  "268": "琼瑶精选",
  "269": "青春文学",
  "270": "经典名著",
  "271": "古典名著",
  "272": "外国名著",
  "273": "近代名家",
  "274": "健康心灵",
  "275": "保健养生",
  "276": "宗教哲学",
  "277": "生活随笔",
  "278": "当代文学",
  "279": "长篇小说",
  "280": "科幻",
  "281": "历史小说",
  "282": "都市职人",
  "283": "现实",
  "284": "现实",
  "285": "现实",
  "286": "现实",
  "287": "经典读本",
  "288": "经管励志",
  "289": "军事谍战",
  "290": "人文社科",
  "291": "诗歌散文",
  "292": "商战权谋",
  "293": "影视传奇",
  "294": "纪实文学",
  "295": "名人传记"
}

export { book_list, cate_map, short_book, video_list }



// WEBPACK FOOTER //
// ./src/module/active_80y/books.js